// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2zXVB","popShow":"styles_popShow__eCCw-","success":"styles_success__3-FX2","adv_word":"styles_adv_word__2PJ9i","btn_box":"styles_btn_box__3hiAY"};